import { useIntl } from '@/intl'
import * as React from 'react'
import { useCallback, useEffect } from 'react'

export function useDateCountdown(endDate: string) {
  const intl = useIntl()
  const [timeToEnd, setTimeToEnd] = React.useState<string>('')
  const [counterEnded, setCounterEnded] = React.useState<boolean>(false)

  function getAbbreviatedTimeUnit(value: number, unit: 'day' | 'hour' | 'minute' | 'second') {
    const formatted = intl.formatNumber(value, { style: 'unit', unitDisplay: 'narrow', unit })
    return formatted.replace(/\s/g, '')
  }

  const pad = (value: string) => value.padStart(3, '0')

  const countTimeToEnd = useCallback((interval: NodeJS.Timeout) => {
    const endDateTime = endDate.includes('T') ? endDate : `${endDate}T00:00:00`
    const deadline = new Date(endDateTime)
    const today = new Date()
    const timeDifference = deadline.getTime() - today.getTime()
    if (timeDifference <= 0) {
      setCounterEnded(true)
      clearInterval(interval)
      return
    }

    const days = getAbbreviatedTimeUnit(Math.floor(timeDifference / (1000 * 60 * 60 * 24)), 'day')
    const hours = getAbbreviatedTimeUnit(Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 'hour')
    const minutes = getAbbreviatedTimeUnit(Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)), 'minute')
    const seconds = getAbbreviatedTimeUnit(Math.floor((timeDifference % (1000 * 60)) / 1000), 'second')
    setTimeToEnd(`${pad(days)}  ${pad(hours)}  ${pad(minutes)}  ${pad(seconds)}`)
  }, [endDate])

  useEffect(() => {
    const interval: NodeJS.Timeout = setInterval(() => countTimeToEnd(interval), 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])
  return {
    counterEnded,
    timeToEnd,
  }
}
